import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';
import api from '../api';

const LoginForm = () => {
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_ENDPOINT;
    const [latestPoster, setLatestPoster] = useState(null);
    const [activeEvents, setActiveEvents] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loginCollapsed, setLoginCollapsed] = useState(false);
    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const res = await api.post(`${apiUrl}/api/auth/signin`, formData);
            login({
                ...res.data,
                token: res.data.token,
                refreshToken: res.data.refreshToken,
            });

            const role = res.data.roles[0];
            switch (role) {
                case 'ROLE_ADMIN':
                    navigate('/admin');
                    break;
                case 'ROLE_PESERTA':
                    navigate('/peserta');
                    break;

                default:
                    navigate('/');
            }
        } catch (err) {
            alert('Login failed. Please check your credentials (Email or Password).');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setIsLoading(true);
        api.get(`${apiUrl}/api/public/active-events`)
            .then(res => {
                setActiveEvents(res.data);
                setIsLoading(false);
            })
            .catch(err => {
                console.error(err);
                setIsLoading(false);
            });
    }, [apiUrl]);

    // Auto-slide effect
    useEffect(() => {
        if (activeEvents.length > 1) {
            const interval = setInterval(() => {
                setCurrentSlide((prev) => (prev + 1) % activeEvents.length);
            }, 5000); // Change slide every 5 seconds

            return () => clearInterval(interval);
        }
    }, [activeEvents.length]);

    useEffect(() => {
        setIsLoading(true);
        api.get(`${apiUrl}/api/public/latest-poster`)
            .then(res => {
                setLatestPoster(res.data);
                setIsLoading(false);
            })
            .catch(err => {
                console.error(err);
                setIsLoading(false);
            });
    }, [apiUrl]);


    return (
        <div className="d-flex flex-column bg-white">
            <div className="row g-0 flex-fill">


                <div
                    className={`col-12 col-lg-6 col-xl-4 border-top-wide border-primary d-flex flex-column justify-content-start position-relative ${loginCollapsed ? 'd-none' : ''}`}
                    style={{ minHeight: '100vh' }}
                >
                    <button
                        type="button"
                        className="btn btn-light border shadow-sm position-absolute rounded-circle p-0 d-flex align-items-center justify-content-center"
                        style={{
                            top: '50%',
                            right: 0,
                            transform: 'translate(50%, -50%)',
                            zIndex: 20,
                            width: 32,
                            height: 32,
                            fontSize: '1rem',
                            lineHeight: 1,
                        }}
                        onClick={() => setLoginCollapsed(true)}
                        title="Sembunyikan panel login"
                        aria-label="Sembunyikan panel login"
                    >
                        <span aria-hidden="true">&lt;</span>
                    </button>

                    <div className="container container-tight my-5 px-lg-5">
                        <div className="text-center mb-4">
                            <img src="./static/idai_putih.jpg" width={160} alt="Logo" />
                        </div>
                        <h2 className="h3 text-center mb-3">Login to your account</h2>
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="username"
                                    placeholder="Your Email"
                                    value={formData.username}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                            </div>
                            <div className="mb-2">
                                <label className="form-label">
                                    Password
                                    <span className="form-label-description">
                                        {/* <a href="./forgot-password.html">I forgot password</a> */}
                                        <Link to="/forgot-password" className="comp-forgot-password comp-s-regular">Forgot Password?</Link>
                                    </span>
                                </label>
                                <div className="input-group input-group-flat">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className="form-control"
                                        name="password"
                                        placeholder="Your password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        autoComplete="off"
                                    />
                                    <span className="input-group-text">
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="border-0 bg-transparent p-0 m-0"
                                            title={showPassword ? 'Hide password' : 'Show password'}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                                            </svg>
                                        </button>
                                    </span>
                                </div>
                            </div>
                            <div className="mb-2">
                                {/* <label className="form-check">
                                    <input type="checkbox" className="form-check-input" />
                                    <span className="form-check-label">Remember me on this device</span>
                                </label> */}
                            </div>
                            <div className="form-footer">
                                <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Signing in...
                                        </>
                                    ) : (
                                        'Sign in'
                                    )}
                                </button>

                            </div>
                        </form>
                        <div className="text-center mt-3">
                            <span>Have no Account ? </span>
                            <Link to="/register">Register</Link>
                        </div>
                    </div>
                </div>


                {loginCollapsed && (
                    <button
                        type="button"
                        className="btn btn-light border shadow-sm position-fixed rounded-circle p-0 d-flex align-items-center justify-content-center"
                        style={{
                            top: '50%',
                            left: 12,
                            transform: 'translateY(-50%)',
                            zIndex: 1050,
                            width: 36,
                            height: 36,
                            fontSize: '1rem',
                        }}
                        onClick={() => setLoginCollapsed(false)}
                        title="Tampilkan panel login"
                        aria-label="Tampilkan panel login"
                    >
                        <span aria-hidden="true">&gt;</span>
                    </button>
                )}

                {/* Poster Kanan dengan Slider */}
                <div
                    className={loginCollapsed ? 'col-12 d-block' : 'col-12 col-lg-6 col-xl-8 d-none d-lg-block'}
                    style={{ padding: 0, margin: 0, overflow: 'hidden' }}
                >
                    <div
                        className={`h-100 min-vh-100 d-flex position-relative ${
                            loginCollapsed ? 'align-items-stretch w-100' : 'align-items-center justify-content-center'
                        }`}
                        style={{
                            padding: 0,
                            margin: 0,
                            width: '100%',
                            overflow: 'hidden',
                            background: '#38a6b0',
                        }}
                    >
                        {isLoading ? (
                            <div className="spinner-border text-white" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        ) : activeEvents.length > 0 ? (
                            <>
                                {/* Container untuk slider yang lebih kecil */}
                                <div
                                    className="position-relative"
                                    style={
                                        loginCollapsed
                                            ? {
                                                  width: '100%',
                                                  height: '100vh',
                                                  minHeight: '100vh',
                                                  flex: '1 1 auto',
                                              }
                                            : {
                                                  width: '100%',
                                                  maxWidth: '100%',
                                                  height: 'min(85vh, 800px)',
                                                  maxHeight: '800px',
                                              }
                                    }
                                >
                                    {/* Image Slider */}
                                    <div
                                        className={`position-relative w-100 h-100 shadow-lg overflow-hidden ${
                                            loginCollapsed ? 'rounded-0' : 'rounded-4'
                                        }`}
                                        style={{
                                            border: loginCollapsed
                                                ? 'none'
                                                : '3px solid rgba(255,255,255,0.2)',
                                            boxShadow: loginCollapsed
                                                ? 'none'
                                                : '0 20px 40px rgba(0,0,0,0.3)',
                                            backgroundColor: '#38a6b0',
                                        }}
                                    >
                                        {activeEvents.map((event, index) => (
                                            <div
                                                key={event.id}
                                                className={`position-absolute w-100 h-100 transition-opacity ${
                                                    index === currentSlide ? 'opacity-100' : 'opacity-0'
                                                }`}
                                                style={{
                                                    transition: 'opacity 0.8s ease-in-out',
                                                    zIndex: index === currentSlide ? 1 : 0
                                                }}
                                            >
                                                <img
                                                    src={`${apiUrl}/api/public/displayimage/${event.posterUrl}`}
                                                    alt={`Poster ${event.title}`}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        objectPosition: 'center',
                                                        display: 'block',
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>

                                    {/* Navigation Dots */}
                                    {activeEvents.length > 1 && (
                                        <div className="position-absolute bottom-0 start-50 translate-middle-x mb-4" style={{ zIndex: 10 }}>
                                            <div className="d-flex gap-3">
                                                {activeEvents.map((_, index) => (
                                                    <button
                                                        key={index}
                                                        type="button"
                                                        className={`btn rounded-circle border-0 ${
                                                            index === currentSlide 
                                                                ? 'bg-white' 
                                                                : 'bg-white bg-opacity-50'
                                                        }`}
                                                        style={{ 
                                                            width: '16px', 
                                                            height: '16px', 
                                                            padding: 0,
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onClick={() => setCurrentSlide(index)}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Event Info Card */}
                                    {activeEvents[currentSlide] && (
                                        <div className="position-absolute bottom-0 start-0 w-100 p-4" style={{ 
                                            background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%)',
                                            zIndex: 5
                                        }}>
                                            <div className="text-white">
                                                <h4 className="mb-2 fw-bold">{activeEvents[currentSlide].title}</h4>
                                                <div className="d-flex align-items-center gap-3 text-white-50">
                                                    <div className="d-flex align-items-center gap-1">
                                                        <i className="bi bi-calendar-event"></i>
                                                        <span>{activeEvents[currentSlide].startDate}</span>
                                                    </div>
                                                    {activeEvents[currentSlide].locationName && (
                                                        <div className="d-flex align-items-center gap-1">
                                                            <i className="bi bi-geo-alt"></i>
                                                            <span>{activeEvents[currentSlide].locationName}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Slide Counter */}
                                    {activeEvents.length > 1 && (
                                        <div className="position-absolute top-3 end-3 bg-dark bg-opacity-75 text-white px-3 py-1 rounded-pill" style={{ zIndex: 10 }}>
                                            <small>{currentSlide + 1} / {activeEvents.length}</small>
                                        </div>
                                    )}
                                </div>

                                {/* Background Decorative Elements */}
                                <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 0 }}>
                                    <div className="position-absolute top-20 start-10 opacity-10">
                                        <i className="bi bi-calendar-check" style={{ fontSize: '8rem', color: 'white' }}></i>
                                    </div>
                                    <div className="position-absolute bottom-20 end-10 opacity-10">
                                        <i className="bi bi-people" style={{ fontSize: '6rem', color: 'white' }}></i>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="text-center text-white">
                                <div className="display-4 fw-bold mb-3">
                                    <i className="bi bi-calendar-x mb-3 d-block" style={{ fontSize: "4rem" }}></i>
                                    Belum ada Event
                                </div>
                                <div className="lead opacity-75">
                                    Silakan cek kembali nanti untuk event terbaru.
                                </div>
                            </div>
                        )}
                    </div>
                </div>



            </div>
        </div>
    );
};

export default LoginForm;
